<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  translate25Context: 'vfigma',
  props: ["title2", "close", "pending", "closable"],
  methods: {},
};
</script>

<template>
  <div class="f-dialog" :class="{ pending: pending }">
    <f-button
      v-if="closable"
      class="f-dialog-close"
      type="icon transparent"
      v-on:click="$emit('close')"
      ><f-icon icon="fa6-xmark"></f-icon
    ></f-button>
    <div class="f-dialog-title">
      <slot name="title2" v-if="$slots.title2"></slot>
      <span v-else>{{ $vt(title2) }}</span>
    </div>
    <div class="f-dialog-content">
      <slot name="content"></slot>
    </div>
    <div class="f-dialog-action">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<style lang="scss">
.f-dialog {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  padding: 28px 56px 32px 56px;
  box-shadow: 0px 24px 48px rgba(22, 22, 21, 0.25);
  min-width: 430px;
  min-height: 219px;
  position: relative;
  overflow: hidden;

  &.pending:before {
    content: "";
    position: absolute;
    left: -100%;
    top: 0;
    height: 5px;
    width: 100%;
    background-color: #ffe601;
    animation: pending 1s infinite;
  }

  &.pending:after {
    content: "";
    position: absolute;
    top: 5px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .f-dialog-close {
    position: absolute;
    top: 8px;
    right: 12px;
  }

  .f-dialog-title {
    display: flex;
    gap: 7px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    color: rgba(22, 22, 21, 1);
  }

  .f-dialog-content {
    margin: 24px 0px;
    font-size: 14px;
  }

  .f-dialog-action {
    display: flex;
    flex-direction: row;
    justify-content: end;
    gap: 16px;
  }
}

.dark-mode {
  .f-dialog {
    background-color: var(--black);
    box-shadow: 0px 24px 48px 0px rgba(22, 22, 21, 0.25);

    &.pending:before {
      content: none;
    }

    &.pending:after {
      background-color: var(--white-a5);
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      inset: 0;
    }

    .f-dialog-title {
      color: var(--white-a75);
      font-family: Lato;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%; /* 35.2px */
    }
  }

  .f-dialog-content {
    color: var(--white-a75);
  }
}
</style>